module.exports = __webpack_public_path__ + "img/94.ab8fe566.jpg";